import { Draggable } from "@hello-pangea/dnd";
import { Device } from "api/types/device";
import CircleButton from "widgets/controls/buttons/circle-button";
import { MdDelete } from "react-icons/md";

type AssignedDeviceCardProps = {
  draggableId: string;
  index: number;
  device: Device;
  onRemove: () => void;
};

/** Edit the card style here - used for devices in Source, Zone, and Device columns */
const CARD_CLASS =
  "border-stone-200 dark:border-stone-600 dark:bg-stone-800 mb-2 flex cursor-grab items-start justify-between gap-2 rounded-lg border bg-white px-3 py-2 shadow-sm transition-colors active:cursor-grabbing";

export function AssignedDeviceCard({
  draggableId,
  index,
  device,
  onRemove,
}: AssignedDeviceCardProps) {
  return (
    <Draggable key={draggableId} draggableId={draggableId} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`${CARD_CLASS} ${snapshot.isDragging ? "shadow-lg" : ""}`}
        >
          <div {...provided.dragHandleProps} className="min-w-0 flex-1 overflow-hidden">
            <span className="block truncate text-sm font-medium text-primary">
              {device.name || device.snr}
            </span>
            <span className="text-stone-500 dark:text-stone-400 block truncate text-xs text-secondary">
              SNR: {device.snr}
            </span>
          </div>
          <div className="shrink-0">
            <CircleButton
              icon={MdDelete}
              onClick={onRemove}
              size="xs"
              color="red"
              variant="ghost"
              tooltip="Remove device"
            />
          </div>
        </div>
      )}
    </Draggable>
  );
}
